
<h2 mat-dialog-title class="dialog-header">
  <div class="d-flex flex-row justify-content-between mb-4">
    <div class="d-flex flex-column">
      <div class="d-flex">
        <div class="mat-body-2 text-black mb-4">
          {{ dialogMessages.dialogTitle }}
        </div>
      </div>
      <div class="mat-subtitle-2 text-hint mb-4">
        {{ dialogMessages.dialogDescription }}
      </div>
    </div>

    <button mat-icon-button class="dialog-close-btn" (click)="close()">
      <mat-icon class="text-hint">cancel</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>
  <div class="mb-4"></div>
</h2>

<mat-dialog-content>
  <mat-accordion *ngIf="broadcastDataSource && broadcastDataSource.length > 0">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="panel-title">{{ dialogMessages.broadcastTableTitle }}</span>
          <p class="panel-description">
            {{ generalMessages.TIMEZONE_NOTE }}
            <span class="secondary-text">
              {{ data.timezone?.timezone_label }} ({{ data.timezone?.timezone_abbr }})
            </span>
          </p>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="table-container">
        <table mat-table [dataSource]="broadcastDataSource" class="mat-elevation-z0">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="fixed-short">ID</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.id" [matTooltipShowDelay]="tooltipDelay"
              class="fixed-short">
              {{ data.id }}
            </td>
          </ng-container>

          <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef class="fixed-large">Message</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.message" [matTooltipShowDelay]="tooltipDelay"
              class="fixed-large">
              {{ data.message }}
            </td>
          </ng-container>

          <ng-container matColumnDef="schedule_time">
            <th mat-header-cell *matHeaderCellDef class="fixed-medium">Date Time</th>
            <td mat-cell *matCellDef="let data"
              [matTooltip]="(data.schedule_time || data.sent_date | momentTimezonePipe: timezone.timezone_identifier : dateTimeFormats.mediumDateTime) || data.schedule_time"
              [matTooltipShowDelay]="tooltipDelay" class="fixed-medium">
              {{ data.schedule_time || data.sent_date | momentTimezonePipe: timezone.timezone_identifier : dateTimeFormats.mediumDateTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="comm_status">
            <th mat-header-cell *matHeaderCellDef class="fixed-short">Status</th>
            <td mat-cell *matCellDef="let data" class="fixed-short">
              <div *ngIf="getStatusValue(data.comm_status) as _statusData" class="status-badge"
                [class]="'text-badge ' + _statusData.class" [matTooltip]="_statusData.value">
                <div class="mat-caption m-0">{{ _statusData.value | uppercase }}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="channels">
            <th mat-header-cell *matHeaderCellDef class="fixed-medium">Channels</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.channels" [matTooltipShowDelay]="tooltipDelay"
              class="fixed-medium">
              {{ data.channels }}
            </td>
          </ng-container>

          <ng-container matColumnDef="interests">
            <th mat-header-cell *matHeaderCellDef class="fixed-medium">Interests</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.interests" [matTooltipShowDelay]="tooltipDelay"
              class="fixed-medium">
              {{ data.interests }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="broadcastDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: broadcastDisplayedColumns;"></tr>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion *ngIf="surveryDataSource && surveryDataSource.length > 0">
    <mat-expansion-panel class="mt-16" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="panel-title">{{ dialogMessages.surveyTableTitle }}</span>
          <p class="panel-description">
            {{ generalMessages.TIMEZONE_NOTE }}
            <span class="secondary-text">
              {{ data.timezone?.timezone_label }} ({{ data.timezone?.timezone_abbr }})
            </span>
          </p>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="table-container">
        <table mat-table [dataSource]="surveryDataSource" class="mat-elevation-z0">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="fixed-short">ID</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.run_id || data.id"
              [matTooltipShowDelay]="tooltipDelay" class="fixed-short">
              {{ data.run_id || data.id }}
            </td>
          </ng-container>

          <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef class="fixed-large">Title</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.message" [matTooltipShowDelay]="tooltipDelay"
              class="fixed-large">
              {{ data.message }}
            </td>
          </ng-container>

          <ng-container matColumnDef="schedule_time">
            <th mat-header-cell *matHeaderCellDef class="fixed-medium">Date Time</th>
            <td mat-cell *matCellDef="let data"
              [matTooltip]="(data.schedule_time || data.sent_date | momentTimezonePipe: timezone.timezone_identifier : dateTimeFormats.mediumDateTime) || data.schedule_time"
              [matTooltipShowDelay]="tooltipDelay" class="fixed-medium">
              {{ data.schedule_time || data.sent_date | momentTimezonePipe: timezone.timezone_identifier : dateTimeFormats.mediumDateTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="comm_status">
            <th mat-header-cell *matHeaderCellDef class="fixed-short">Status</th>
            <td mat-cell *matCellDef="let data" class="fixed-short">
              <div *ngIf="getStatusValue(data.comm_status) as _statusData" class="status-badge"
                [class]="'text-badge ' + _statusData.class" [matTooltip]="_statusData.value">
                <div class="mat-caption m-0">{{ _statusData.value | uppercase }}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="channels">
            <th mat-header-cell *matHeaderCellDef class="fixed-medium">Channels</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.channels" [matTooltipShowDelay]="tooltipDelay"
              class="fixed-medium">
              {{ data.channels }}
            </td>
          </ng-container>

          <ng-container matColumnDef="interests">
            <th mat-header-cell *matHeaderCellDef class="fixed-medium">Interests</th>
            <td mat-cell *matCellDef="let data" [matTooltip]="data.interests" [matTooltipShowDelay]="tooltipDelay"
              class="fixed-medium">
              {{ data.interests }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="surveyDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: surveyDisplayedColumns;"></tr>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>